import { useEffect, useRef, useState } from 'react';

/**
 * Element ko'ringanida 0 dan `target` gacha animatsiya qiladi.
 * IntersectionObserver bilan — sahifa yuklanishida emas, ko'rinishda ishga tushadi.
 */
export function useCountUp<T extends HTMLElement = HTMLDivElement>(target: number, durationMs = 1400) {
  const [value, setValue] = useState(0);
  const ref = useRef<T>(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const tick = (now: number) => {
            const progress = Math.min(1, (now - start) / durationMs);
            // easeOutCubic
            const eased = 1 - Math.pow(1 - progress, 3);
            setValue(Math.round(target * eased));
            if (progress < 1) requestAnimationFrame(tick);
          };
          requestAnimationFrame(tick);
        }
      },
      { threshold: 0.4 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [target, durationMs]);

  return { value, ref };
}
